<template lang="pug">
  .telegram-setup

    h2.mb-3 Telegram
    span(v-if="!$user.data.telegram") Привяжите Telegram чтобы открыть доступ в группы.
      |  Для этого cкопируйте код и отправьте Telegram боту.

    v-list.pb-0(v-if="!$user.data.telegram")
      v-list-item.px-0
        v-list-item-avatar
          v-avatar(color="grey lighten-3")
            strong.secondary--text 1
        v-list-item-content
          h3 Скопируете код
      copy-clipboard-field(
        :value="hash"
        filled
      )
      v-list-item.px-0.mt-3.mb-1
        v-list-item-avatar
          v-avatar(color="grey lighten-3")
            strong.secondary--text 2
        v-list-item-content
          h3 Перейдите в Telegram бота
          span.caption.grey--text(v-if="!isMobile") или отсканируете qr-code
        v-list-item-action(v-if="!isMobile")
          v-menu(
            bottom
            open-on-hover
            offset-y
          )
            template(v-slot:activator="{ on }")
              v-btn(
                v-on="on"
                color="secondary"
                fab depressed
              ): v-icon mdi-qrcode
            v-sheet.pa-4.pb-3
              qr-code.text-center(
                :value="`${$conf.TELEGRAM_URL}?start=${hash}`"
                size="240"
              )
      v-btn(
        color="secondary"
        depressed
        rounded block
        x-large
        target="_blank"
        :href="$conf.TELEGRAM_URL"
        @click="telegramOpened = true"
      ) Открыть Telegram бота
      .ml-13

      v-list-item.px-0.mt-4
        v-list-item-avatar
          v-avatar(color="grey lighten-3")
            strong.secondary--text 3
        v-list-item-content.ml-2
          v-list-item-title: h3 Проверьте привязку
          v-list-item-subtitle(v-if="firstCheck").error--text Телеграм не найден
      v-btn.mt-2(
        depressed
        rounded color="success"
        x-large block
        :loading="loading.check"
        @click="checkTelegram()"
      ) Проверить
    v-list.pb-0(v-if="$user.data.telegram")
      v-list-item.px-0
        v-list-item-avatar
          v-avatar(
            color="success"
          ): v-icon mdi-check
        v-list-item-content
          v-list-item-subtitle Вы привязали телеграм @{{ $user.data.telegram.telegram_username }}
</template>

<script>
export default {
  data: () => ({
    hash: '',
    telegramOpened: false,
    firstCheck: false,
    loading: {
      check: false,
    },
  }),
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp;
    },
  },
  async created() {
    const { item } = await this.$api.telegram.userHash();
    this.hash = item.hash;
    if (this.$user.data.telegram) this.checkTelegram();
  },

  methods: {
    async checkTelegram() {
      this.loading.check = true;
      await this.$user.syncUser();
      if (this.$user.data.telegram) this.$modals.close();
      this.firstCheck = true;
      this.loading.check = false;
    },
  },
};
</script>
